export enum WIDGET_DEVICE_TYPE {
  COMPUTER = 'computer',
  SMARTPHONE = 'smartphone',
}
